<template>
    <div>
        <a class  = "audit-menu" @click ="onClick">
            <div
                v-if="label"
                class  = "fab-button"
            >
                <div
                    class  = "fab-icon primary-border"
                >
                    <v-icon size="22" color="primary">{{ icon }}</v-icon>
                </div>
                <div class="fab-label">
                    {{ label }}
                </div>
            </div>

            <div
                v-if="!label"
                class  = "fab-button v-flex"
            >
                <v-icon size="22" color="primary">{{ icon }}</v-icon>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "CFabButton",

    props: {
        label: {

        },

        icon: {

        },

        columns: {
            required: false,
            default : function () {
                return 1;
            }
        }
    },

    methods: {
        onClick () {
            this.$emit("click");
        }
    }
}
</script>

<style lang="scss" scoped>


.fab-button  {
    width: 40px;
    min-width: 40px;
    z-index: 100;
}

.fab-button-small  {
    width: 60px;
    min-width: 60px;
    z-index: 100;
    position: relative;
}

.fab-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 20px;
    text-align: center;
    padding-top: 6px;
    margin-left: auto;
    margin-right: auto;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    background-color: white;
}

.fab-label {
    margin-top: 4px;
    font-size: 11px;
    text-align: center;
}

</style>
